import { render, staticRenderFns } from "./StirpesAge.vue?vue&type=template&id=59dfde5d"
import script from "./StirpesAge.vue?vue&type=script&lang=js"
export * from "./StirpesAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports